module.exports = __webpack_public_path__ + "img/Familia_5.abde307c.jpg";